import { useAnalytics as useBaseAnalytics } from '@app/analytics/use-analytics';
import { AllowedEvents } from '@app/features/analytics/types';
import { selectOrganizationInfo } from '@app/routes/organization/selectors';
import { selectOrganizationId, selectUserProfile } from '@app/store/selectors';
import { useAppSelector } from '@app/store/store';
import { useMemo } from 'react';

// Helper function to detect browser from user agent
const getBrowserInfo = () => {
  const userAgent = navigator.userAgent;
  if (userAgent.includes('Chrome')) return 'Chrome';
  if (userAgent.includes('Firefox')) return 'Firefox';
  if (userAgent.includes('Safari')) return 'Safari';
  if (userAgent.includes('Edge')) return 'Edge';
  return 'Unknown';
};

// Helper function to detect OS from user agent
const getOSInfo = () => {
  const userAgent = navigator.userAgent;
  if (userAgent.includes('Windows')) return 'Windows';
  if (userAgent.includes('Mac')) return 'macOS';
  if (userAgent.includes('Linux')) return 'Linux';
  if (userAgent.includes('Android')) return 'Android';
  if (userAgent.includes('iOS')) return 'iOS';
  return 'Unknown';
};

export function useAnalytics() {
  const orgId = useAppSelector(selectOrganizationId) || '';
  const organizationData = useAppSelector(selectOrganizationInfo);
  const userDetails = useAppSelector(selectUserProfile);

  // Memoize common properties to avoid recalculating on every render
  const commonProperties = useMemo(() => {
    return {
      // App identification
      appName: 'RCE Org level Analytics',

      // User information
      userEmail: userDetails?.email || undefined,

      // Organization/Account information
      accountId: orgId,
      orgName: organizationData?.name || undefined,

      // Payment plan information
      userPlan: organizationData?.paymentPlan?.planName || undefined,

      // Browser and device information
      userBrowser: getBrowserInfo(),
      userOS: getOSInfo(),
    };
  }, [
    orgId,
    userDetails?.email,
    organizationData?.paymentPlan?.planName,
    organizationData?.name,
  ]);

  return useBaseAnalytics<AllowedEvents>(commonProperties);
}
